import * as React from "react";

/** Action Hub dashboard icon - a checked inbox card with a node linked to it. Same 25px / brand-blue style as TaskIcon. */
const ActionHubIcon = ({ color = "#006CB8", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    viewBox="0 0 25 25"
    {...props}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M5.2 3.2A2.4 2.4 0 0 0 2.8 5.6v13.8a2.4 2.4 0 0 0 2.4 2.4h7.1a7.4 7.4 0 0 1-.9-1.6H5.2a.8.8 0 0 1-.8-.8V5.6a.8.8 0 0 1 .8-.8h10.4a.8.8 0 0 1 .8.8v3.3a7.4 7.4 0 0 1 1.6.4V5.6a2.4 2.4 0 0 0-2.4-2.4H5.2Zm1 4.4a.8.8 0 0 0 0 1.6h6.4a.8.8 0 0 0 0-1.6H6.2Zm0 4.4a.8.8 0 0 0 0 1.6h3.6a.8.8 0 0 0 0-1.6H6.2Z"
      clipRule="evenodd"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M17.9 9.6a5.7 5.7 0 1 0 0 11.4 5.7 5.7 0 0 0 0-11.4Zm2.6 4.4a.8.8 0 0 1 0 1.1l-3 3a.8.8 0 0 1-1.1 0l-1.5-1.5a.8.8 0 1 1 1.1-1.1l.9.9 2.5-2.5a.8.8 0 0 1 1.1 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default ActionHubIcon;
